import styled, { css } from "styled-components/macro";
import Modal from "react-modal";
import { mobile } from "../../../utils/css/media";
import { colorWhite } from "../../../utils/css/colors";
import { inputBorderRadius } from "../../../utils/css/sizes";

export const StyledModal = styled(Modal)`
  background-color: ${colorWhite};
  border-radius: ${inputBorderRadius}px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.7);
  padding: 1rem;
  :focus {
    outline: 0;
  }
  ${mobile(css`
    width: 78% !important;
  `)};
`;

export const StyledCoverModal = styled(Modal)`
  background-color: ${colorWhite};
  padding: 20px;
  box-shadow: 0;
  border: 2px solid red;
  overflow-y: auto;
  ${mobile(css`
    width: 100vw;
  `)};
`;
export const ImgContainer = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;
